import { Box, Button, Card, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Timestamp } from "firebase/firestore";
import CreateClassDialog from "../components/CreateClassDialog";
import { useEffect, useState } from "react";
import { GetAllClasses, GetAllClassesWithPermission } from '../FirebaseQueries';
import dayjs from "dayjs";
import { scenarioTitles } from "../Scenarios/Scenarios";
import { useAuth } from '../AuthProvider';
import { IClass } from "../Types";



export default function Classes() {
	const [openClassDialog, setOpenClassDialog] = useState(false);
	const [classList, setClassList] = useState<IClass[]>([]);
	const { currentUser } = useAuth();
	const dateFormatString = "HH:mm - D MMM, YYYY";
	const userId: string = currentUser !== null ? currentUser.uid : "";

	useEffect(() => {
		const getAllClasses = async () => {
			try {
				const classesSnapshot = await GetAllClassesWithPermission(userId);
				const value: IClass[] = [];
				classesSnapshot.forEach((doc) => {
					value.push({
						id: doc.id,
						code: doc.data().code,
						session: doc.data().session,
						scenarioIndex: doc.data().scenarioIndex,
						startTime: doc.data().startTime,
						endTime: doc.data().endTime,
						dateTimeCreated: doc.data().dateTimeCreated,
						ownerId: doc.data().ownerId,
						editorIds: doc.data().editorIds,
						viewerIds: doc.data().viewerIds,
						canEditByLink: doc.data().canEditByLink,
						canViewByLink: doc.data().canViewByLink
					});
				});

				value.sort((a, b) => b.dateTimeCreated.seconds - a.dateTimeCreated.seconds);
				setClassList(value);
			} catch (err) {
				// TODO
				console.log(err);
			}
		}

		getAllClasses();
	}, []);

	const handleOpenDialog = () => {
		setOpenClassDialog(true);
	}

	const handleCloseDialog = () => {
		setOpenClassDialog(false);
	};

	return (
		<Stack spacing={2}>
			<CreateClassDialog isOpen={openClassDialog} onClose={handleCloseDialog}></CreateClassDialog>
			<Box sx={{ width: 1, display: 'flex', justifyContent: 'right' }}>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
					<Button onClick={handleOpenDialog} variant="contained">Create Class</Button>
				</Box>
			</Box>
			<TableContainer component={Card} sx={{ boxSizing: 'border-box' }}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell align="center">Class</TableCell>
							<TableCell align="center">Session</TableCell>
							<TableCell align="center">Scenario</TableCell>
							<TableCell align="center">Start Time</TableCell>
							<TableCell align="center">End Time</TableCell>
							<TableCell align="center"></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{classList.map((row) => (
							<TableRow
								key={row.id}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell align="center">
									{row.code}
								</TableCell>
								<TableCell align="center">
									{row.session}
								</TableCell>
								<TableCell align="center">
									{scenarioTitles[row.scenarioIndex]}
								</TableCell>
								<TableCell align="center">
									{dayjs(row.startTime.toDate()).format(dateFormatString)}
								</TableCell>
								<TableCell align="center">
									{dayjs(row.endTime.toDate()).format(dateFormatString)}
								</TableCell>
								<TableCell align="right">
									<Button href={"/app/classes/" + row.id} variant="contained">View</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Stack>
	);
}